import { LogWarning } from 'utils/logging';
import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import { triadSuperFetch } from 'utils/superFetch';

interface GetApplicationLinksParams {
  sessionId: string;
  schoolCode: string;
  pageViewId: string;
  leadGuid: string;
}

interface GetApplicationLinksResponse {
  Links?: {
    ApplicationLink?: string;
  };
}

export async function getApplicationLinks({
  sessionId,
  schoolCode,
  pageViewId,
  leadGuid,
}: GetApplicationLinksParams): Promise<{ applicationLink: string }> {
  const [apiError, response] =
    await triadSuperFetch<GetApplicationLinksResponse>(
      `${TRIAD_PROXY_ROUTE}/thankyoulinks`,
      {
        method: 'POST',
        timeout: 3000,
        body: {
          sessionId,
          schoolCode,
          pageViewId,
          leadGuid,
        },
      }
    );

  if (apiError) {
    LogWarning('Error fetching application links', {
      description: apiError.message,
    });
    return { applicationLink: '' };
  }

  return {
    applicationLink: response?.Links?.ApplicationLink ?? '',
  };
}
